import iBS03F_ResultType from '../model/iBS03F_ResultType';
import SensorResultTable from './SensorResultTable';

type propsType = {
    sensorlogs: iBS03F_ResultType[]
}

const COLUMNS = ["no", "app_id", "manufacturer_id", "model", "battery", "flood", "triggered_count", "macaddress", "rssi", "detected", "arrived"];

const SensorLog_iBS03F_Result = (props: propsType) => (
    <SensorResultTable rows={props.sensorlogs} columnKeys={COLUMNS} />
);

export default SensorLog_iBS03F_Result;
